import {useEffect, useState} from "react";
import axios from "axios";
import {API_BASE} from "../utils/api";
import {DataPoint} from "../component/Scatterplot";
import {CALCULATED_FUNCTIONS, OILFIELD_PERCENT, OILFIELD_PRODUCTION_CONST, OILFIELD_WELLS_DEFAULT, TCalculatedFunction} from "../utils/consts";
import {getMedianOfTopPercent} from "../utils/utils";
import {TData} from "./usePDGeothermal";
export interface IRow {
    Ag: number,
    Al: number,
    As: number,
    Au: number,
    B: number,
    Ba: number,
    Be: number,
    Bi: number,
    Br: number,
    Ca: number,
    Cd: number,
    Cl: number,
    Co: number,
    Cr: number,
    Cs: number,
    Cu: number,
    F: number,
    FeTot: number,
    Hg: number,
    I: number,
    K: number,
    KNa: number,
    Li: number,
    Mg: number,
    Mn: number,
    Mo: number,
    N: number,
    Na: number,
    Ni: number,
    P: number,
    Pb: number,
    Rh: number,
    Rb: number,
    S: number,
    HS: number,
    Sb: number,
    Sc: number,
    Se: number,
    Si: number,
    Sn: number,
    Sr: number,
    Ti: number,
    Tl: number,
    U: number,
    V: number,
    W: number,
    Zn: number,
    Ar: number,
    He: number,
    productionRate: number,
}

export interface IChemicalRow {
    id: number;
    title: string;
    production: string;
    cost: string;
}

export type TChemical = IChemicalRow[];
export type TDataOilfield = IRow[];

export const usePDOilfield = () => {
    const [data, setData] = useState<{data: TData, chemical: TChemical}>({data: [], chemical: []});
    const [calculatedData, setCalculatedData] = useState<DataPoint[]>();
    const [wellsAmount, setWellsAmount] = useState<number>(OILFIELD_WELLS_DEFAULT);
    const [oilfieldPercent, setOilfieldPercent] = useState<number>(OILFIELD_PERCENT * 100);
    const [calculatedFunction, setCalculatedFunction] = useState<TCalculatedFunction>(CALCULATED_FUNCTIONS[0]);
    const [loading, setLoading] = useState(true);

    const fetchData = async (country?: string) => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE}/concentration/oilfield${country ? `?country=${country}` : ''}`, {
                headers: {
                  'content-type': 'application/x-www-form-urlencoded',
                }
            });
            setData({data: response.data.data, chemical: response.data.chemical});
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (oilfieldPercent && oilfieldPercent > 0) {
            const medianOfTop10Percent = getMedianOfTopPercent(
              data!.data,
              data!.chemical,
              oilfieldPercent / 100,
              OILFIELD_PRODUCTION_CONST,
              wellsAmount,
              calculatedFunction,
              );
            // console.log(medianOfTop10Percent);
            setCalculatedData(medianOfTop10Percent);
        }

    }, [data, wellsAmount, oilfieldPercent, calculatedFunction]);

    return {
        data,
        calculatedData,
        loading,
        setData,
        fetchData,
        wellsAmount,
        setWellsAmount,
        oilfieldPercent,
        setOilfieldPercent,
        calculatedFunction,
        setCalculatedFunction
    };
}